import { render, staticRenderFns } from "./calfSelection.vue?vue&type=template&id=7896e84b&scoped=true&"
import script from "./calfSelection.vue?vue&type=script&lang=js&"
export * from "./calfSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896e84b",
  null
  
)

export default component.exports